import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { category, categoryRaw } from '../../api/categories-api.service';
import { StateService } from "../../services/state.service";
import { UserApiService } from 'src/app/api/user-api.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-categories',
    templateUrl: './categories.component.html',
    styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {

    @Output() onCategorySelected = new EventEmitter();
    @Input() categories: {
        state: "finish" | "loading";
        value?: categoryRaw[];
    };

    @Input() group: string;
    @Input() mode: string;

    public nuevaCategoriaMode = false;

    private icon = 'mdi:circle-small';

    constructor(public state: StateService,public userApiService:UserApiService) {  }

    ngOnInit() { 

        let data={
            cedula:this.state.getValueOf('user').sub
        }

        this.userApiService.validarPcrc(data).subscribe(data=>{

            if(data==0){
        
                this.mode=""
          
            }

        })

     }

    seleccionarCategoria(category:category) {
        this.onCategorySelected.next(category)
    }

    getFirstCategories(categories:categoryRaw[]){
        return categories.filter(category => !!!category.parent_id)
    }
    
}